import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const statusOptions = [
  { key: 'active', text: 'Active', value: 1 },
  { key: 'inactive', text: 'Inactive', value: 0 }
];

const CreateUserForm = ({
  fullName,
  mobile,
  password,
  email,
  onChangeOfName,
  onChangeOfMobile,
  onChangeOfEmail,
  onChangeOfPassword,
  onChangeOfStatus,
  onChangeOfRole,
  submitting,
  rolesLoading,
  handleSubmit,
  handleBack,
  roleList,
  onChangeOfCohort,
  vmCohortList,
  vmCohortLoading
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title> Create New User </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Create New User
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Full Name</label>
            <input
              disabled={submitting}
              value={fullName}
              onChange={onChangeOfName}
              placeholder="Example: Ram Singh"
            />
          </Form.Field>
          <Form.Field required>
            <label>Mobile Number</label>
            <input
              disabled={submitting}
              value={mobile}
              onChange={onChangeOfMobile}
              placeholder="Example: 9900990090"
            />
          </Form.Field>
          <Form.Field>
            <label>Email</label>
            <input
              disabled={submitting}
              value={email}
              onChange={onChangeOfEmail}
              placeholder="Example: ram.sigh@gmail.com"
            />
          </Form.Field>
          <Form.Field required>
            <label>Password</label>
            <input
              disabled={submitting}
              value={password}
              onChange={onChangeOfPassword}
              placeholder="Example: Strong password"
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Role</label>
            <Dropdown
              disabled={rolesLoading || submitting}
              onChange={onChangeOfRole}
              selection
              search
              options={roleList || []}
            />
          </Form.Field>
          <Form.Field>
            <label>Select VM Cohort</label>
            <Dropdown
              disabled={vmCohortLoading || submitting}
              onChange={onChangeOfCohort}
              selection
              multiple
              search
              options={vmCohortList || []}
            />
          </Form.Field>
          <Form.Field>
            <label>Status</label>
            <Dropdown
              disabled={submitting}
              onChange={onChangeOfStatus}
              selection
              options={statusOptions}
            />
          </Form.Field>
          <Form.Field />
          <Button
            loading={submitting}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Add User
          </Button>
          <Button
            loading={submitting}
            onClick={handleBack}
            basic
            color="green"
            style={{ float: 'left' }}
          >
            Back to Listing
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateUserForm;



// WEBPACK FOOTER //
// ./src/Modules/UsersCreate/component.jsx